import { render, staticRenderFns } from "./wtTabs.component.vue?vue&type=template&id=6d6171a9&scoped=true&"
import script from "./wtTabs.component.vue?vue&type=script&lang=js&"
export * from "./wtTabs.component.vue?vue&type=script&lang=js&"
import style0 from "./wtTabs.component.vue?vue&type=style&index=0&id=6d6171a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6171a9",
  null
  
)

export default component.exports